module.exports = __webpack_public_path__ + "media/images/icons/upload-4b845555aaf2081463337cb8b5c270cf.svg";